import React from "react";

// import { Container } from './styles';
import Navbar from "../../components/Navbar";

export default function Page404() {
  return (
    <div>
      <Navbar />
      <h1>Pagina não existe</h1>
    </div>
  );
}
